import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MainWindow from './MainWindow'
import { getCookieByName } from './cookie'
import ReactGA from 'react-ga';


if (process.env.NODE_ENV === 'production' && getCookieByName() ) {
    ReactGA.initialize('UA-154248742-01');
    ReactGA.pageview(window.location.pathname + window.location.search);
}

ReactDOM.render(
    <MainWindow />,
    document.getElementById('root')
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
